module.exports = __webpack_public_path__ + "img/title-2.3d7aea89.png";